(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["journal-article"]) return;
  try {
    
  (function () {
    function init() {
      var content = document.querySelector('[data-article-content]');
      var nav = document.querySelector('.journal-article__toc');
      if (!content || !nav) return;
      var heads = content.querySelectorAll('h2');
      if (heads.length < 2) return;
      var list = nav.querySelector('[data-toc-list]');
      var links = [];
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });
      nav.hidden = false;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
            }
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach(function (h) { io.observe(h); });
      }
      links[0].classList.add('is-active');
    }
    function share() {
      var btn = document.querySelector('[data-copy-link]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var done = function () { var t = btn.textContent; btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = t; }, 1800); };
        if (navigator.clipboard) { navigator.clipboard.writeText(window.location.href.split('?')[0]).then(done); }
      });
    }
    function boot() { init(); share(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
